import { createAsyncThunk } from '@reduxjs/toolkit';
import { FeedbackRequestDto } from 'shared/api';
import { feedbackApi } from '../../api/feedbackApi';

export const getAllFeedbacks = createAsyncThunk(
  'feedbacks/getAllFeedbacks',
  async () => {
    const response = await feedbackApi.getAllFeedbacks();
    return response;
  },
);

export const getFeedbackById = createAsyncThunk(
  'feedbacks/getFeedbackById',
  async (id: number) => {
    const response = await feedbackApi.getFeedbackById(id);
    return response;
  },
);

export const createFeedback = createAsyncThunk(
  'feedbacks/createFeedback',
  async (data: FeedbackRequestDto) => {
    const response = await feedbackApi.createFeedback(data);
    return response;
  },
);

export const updateFeedback = createAsyncThunk(
  'feedbacks/updateFeedback',
  async ({ id, data }: { id: number; data: FeedbackRequestDto }) => {
    const response = await feedbackApi.updateFeedback(id, data);
    return response;
  },
);

export const deleteFeedback = createAsyncThunk(
  'feedbacks/deleteFeedback',
  async (id: number) => {
    const response = await feedbackApi.deleteFeedback(id);
    return response;
  },
);
